import Assistant from "@/components/Common/Assistant";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Product from "@/components/Product";
import { ProductDetailItemProps } from "@/components/Product/constants";
import axios from "axios";
import { GetStaticPaths, GetStaticProps } from "next";
import Error from "next/error";
import { ParsedUrlQuery } from 'querystring';


interface ProductProps {
  product: ProductDetailItemProps | undefined;
}

interface ProductParams extends ParsedUrlQuery {
  slug: string;
}

const ProductPage = ({
  product,
}: ProductProps) => {

  if (product === undefined) return (<></>)

  return (
    <>
      <Header />
      <Product
        id={product.id}
        name={product.name}
        msrp={product.msrp}
        sales_price={product.sales_price}
        product_code={product.product_code}
        qty={product.qty}
        ranking={product.ranking}
        attribute_value_list={product.attribute_value_list}
        categories_list={product.categories_list}
        product_variant_list={product.product_variant_list}
        image_gallery={product.image_gallery}
        description_list={product.description_list}
        description_media_list={product.description_media_list}
        people_say={product.people_say}
        our_pick={product.our_pick}
        meta={product.meta}
        size_guide={product.size_guide}
        product_label_right_top={product.product_label_right_top}
        product_label_right_product_page={product.product_label_right_product_page}
        product_label_left_product_page={product.product_label_left_product_page}
        urls={product.urls}
        special_price={product.special_price}
        brand={product.brand}
        slug={product.slug}
        rating={product.rating}
        promotion={product.promotion}
        selling_points={product.selling_points}
        how_to_use={product.how_to_use}
        pwp_name={product.pwp_name}
        pwp={product.pwp}
        virtual_product={product.virtual_product}
        need_shipping={product.need_shipping}
        custom_variant_list={product.custom_variant_list}
        video_list={product.video_list}
        use_product_option={product.use_product_option}
        sales_status={product.sales_status}
      />
      <Footer />
    </>
  )
}

export default ProductPage

export const getStaticProps: GetStaticProps<ProductParams> = async ({ params }) => {
  const { slug } = params || {}; // Set a default empty object if params is undefined

  try {
    const response = await axios.get(
      process.env.NEXT_PUBLIC_API_URL! + process.env.NEXT_PUBLIC_API_PRODUCT! + "/" + slug
    );

    return {
      props: { product: response.data, slug: slug ? slug.toString() : '' }, // Ensure 'slug' is of type 'string'
      revalidate: 300,
    }
  } catch (error) {
    console.error("Error fetching product data: ", slug, error);

    if (axios.isAxiosError(error)) {
      if (error.response?.status === 404) {
        return {
          notFound: true,
        }
      } else {
        return (
          <Error statusCode={500} />
        )
      }
    } else {
      return (
        <Error statusCode={500} />
      )
    }
  }
}

export const getStaticPaths: GetStaticPaths<ProductParams> = async () => {
  // 根據API獲取所有可能的slug
  // const response = await fetch('/api/allSlugs');
  // const slugs = await response.json();
  const slugs: Array<string> = ["mooimom-wireless-electric-breast-pump-m3"]

  const paths = slugs.map((slug: string) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: 'blocking',
  };
};
